<template>
  <div class="token-stat-page">
	 <el-form :model="form" inline label-width="80px">
	 	<el-form-item label="学校" v-if="isAdmin">
	 		<el-select v-model="form.schoolId" placeholder="请选择学校">
	 			<el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id" />
	 		</el-select>
	 	</el-form-item>
	 	<el-form-item label="">
	 		<el-select v-model="semesterId" placeholder="请选择学期" @change="forSemester">
	 			<el-option v-for="item in semesterList" :key="item.value" :label="item.label" :value="item.value" />
	 		</el-select>
	 	</el-form-item>
	 	<el-form-item label="">
	 		<el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="起始日期"
	 			end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="rangePickerOption"
	 			@change="forDate" style="width: 260px;" :clearable="false"></el-date-picker>
	 	</el-form-item>
	 </el-form>
   

    <el-card style="margin-top:10px">
      <el-table :data="tableData" border stripe>
        <!-- <el-table-column label="学校ID" prop="schoolId" width="100" /> -->
        <!-- <el-table-column label="学年" prop="year" width="100" /> -->
        <!-- <el-table-column label="学期" prop="term" width="80" /> -->
        <el-table-column label="年级" prop="gradeName" width="100" />
        <!-- <el-table-column label="课程数量" prop="courseCount" width="100" /> -->
        <!-- <el-table-column label="课堂数量" prop="classCount" width="100" /> -->
        <el-table-column label="对话输入Token" prop="chatInput" />
        <el-table-column label="对话输出Token" prop="chatOutput" />
        <el-table-column label="对话总Token" prop="chatTotal" />
        <el-table-column label="作品输入Token" prop="workInput" />
        <el-table-column label="作品输出Token" prop="workOutput" />
        <el-table-column label="作品总Token" prop="workTotal" />
        <el-table-column label="总输入" prop="totalInput" />
        <el-table-column label="总输出" prop="totalOutput" />
        <el-table-column label="全部合计" prop="allTokenTotal" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { schoolId: null, semester: ''},
      startDate: '',
      endDate: '',
      schoolList: [],
      tableData: [],
	  semesterList:[],
	  login:null,
	  rangePickerOption: {
	  	disabledDate: time => this.disabledRangeDate(time)
	  },
	  total: 0,
	  isAdmin: false,
	  pageSize: 10,
	  pageNum: 1,
	  semesterArr: {},
	  oldYear: null,
	  grade: -1,
	  classId: -1,
	  
    }
  },
  created() {
    this.fetchSchool()
  },
  methods: {
	 forSemester(id) {
	 	const arr = this.semesterList.find(v => v.value === this.semesterId)
	 	this.semesterArr = arr
	 	if (!arr) return
	 	this.pageNum = 1
	 	let time = new Date();
	 	let todayZero = new Date(time);
	 	todayZero.setHours(0, 0, 0, 0);
	 	let prevDayEndTs = todayZero.getTime() - 1;
	 
	 	this.semStartTs = arr.startTime
	 	this.semEndTs = arr.endTime
	 	let semEndTs = arr.endTime
	 	let semStartTs = arr.startTime
	 
	 	if (arr.endTime >= prevDayEndTs) {
	 		semEndTs = prevDayEndTs
	 	}
	 	// 自动赋值日期范围 [开始日期,结束日期]
	 	this.dateRange = [this.tsToYmd(semStartTs), this.tsToYmd(semEndTs)]
	 	this.handleQuery()
	 },
	 loginOpen(text) {
	 	this.login = this.$loading({
	 		lock: true,
	 		text,
	 		zIndex: 100001,
	 		spinner: 'el-icon-loading',
	 		background: 'rgba(0,0,0,0.7)'
	 	});
	 },
	 noLogin() {
	 	if (this.login) {
	 		this.login.close();
	 		this.login = null;
	 	}
	 },
	 async fetchSchool() {
	 	this.loginOpen('初始化中...')
	 	if (localStorage.getItem('userType') == 1) {
	 		this.isAdmin = true
	 	}
	 	if (localStorage.getItem('userType') == 2) {
	 		this.form.schoolId = localStorage.getItem('orgId')
	 		var name = localStorage.getItem('orgName')
	 		this.schoolList = [{
	 			id: this.form.schoolId,
	 			name: name
	 		}]
	 	}
	 	if (localStorage.getItem('semester')) {
	 		let list = JSON.parse(localStorage.getItem('semester'))
	 		this.semesterList = list?.map(v => {
	 			v.label = `${v.year}-${Number(v.year) + 1}学年${v.term == 1 ? "第一学期" : "第二学期"}`
	 			v.value = v.id
	 			return {
	 				...v
	 			}
	 		})
	 		this.semesterId = this.semesterList?.find(v => v.status == 1).value || null
	 		this.oldYear = this.semesterList?.find(v => v.status == 1).year || null
	 		this.noLogin()
	 		this.forSemester()
	 	}
	 },
	 disabledRangeDate(time) {
	   if (!this.semStartTs || !this.semEndTs) return false
	   const dayTs = time.getTime()
	   return dayTs < this.semStartTs || dayTs > this.semEndTs
	 },
	 handleCurrentChange(page) {
	   this.pageNum = page
	   this.handleQuery()
	 },
	 forDate(){
	 	this.pageNum=1
	 	this.handleQuery()
	 },
	
	  tsToYmd(ts) {
	    if (!ts) return ''
	    const d = new Date(ts)
	    const year = d.getFullYear()
	    const month = String(d.getMonth() + 1).padStart(2, '0')
	    const day = String(d.getDate()).padStart(2, '0')
	    return `${year}-${month}-${day}`
	  },
	  totime(val, type) {
		  if(!val) return ''
	  	var time = new Date(val).getTime()
	  	if (type == 2) {
	  		time = time + 16 * 60 * 60 * 1000
	  	} else {
	  		time = time - 8 * 60 * 60 * 1000
	  	}
	  	return time
	  },
    async handleQuery() {
    	if (!this.form.schoolId || !this.dateRange || this.dateRange.length !== 2) {
    		this.$message.warning('请完善筛选条件')
    		return
    	}
    	const [startDay, endDay] = this.dateRange
    	const selectStartTs = new Date(startDay).getTime()
    	const selectEndTs = new Date(endDay).getTime()
    
    	// 校验选中日期不能超出学期区间
    	if (selectStartTs < this.semStartTs || selectEndTs > this.semEndTs) {
    		this.$message.warning(
    			`日期必须在学期范围：${this.tsToYmd(this.semStartTs)} ~ ${this.tsToYmd(this.semEndTs)}`)
    		return
    	}
    	if (selectStartTs > selectEndTs) {
    		this.$message.warning('起始时间不能晚于结束时间')
    		return
    	}
    
    	this.loginOpen('数据查询中...')
    	let grade = this.grade == -1 ? null : (Number(this.grade) - Number(this.oldYear) + Number(this
    		.semesterArr.year))
    	try {
    		const res = await this.API.get(this.API.fileurl.getGradeDateMessage, {
    			schoolId: this.form.schoolId,
    			statDate: startDay,
    			endDate: endDay,
    			term: this.semesterArr.term,
    			year: this.semesterArr.year,
    			pageNum: this.pageNum,
    			grade: grade,
    			pageSize: this.pageSize,
    		})
    		let list = res?.data?.data?.records || []
    		this.tableData = list?.map((v,i) => {
    			v.chatInput = 0
    			v.chatOutput = 0
    			v.workInput = 0
    			v.workOutput = 0
    			v.index=(this.pageNum-1)*this.pageSize+i+1
    			// var name = v.areaName ? `${v.className}(${v.areaName})` : v.className
    			// v.className = name
    			v.tokenList.map(a => {
    				if (a.source == 1) {
    					v.chatInput = v.chatInput + Number(a.totalRequestToken)
    					v.chatOutput = v.chatOutput + Number(a.totalConsumeToken)
    				}
    				if (a.source == 2) {
    					v.workInput = v.workInput + Number(a.totalRequestToken)
    					v.workOutput = v.workOutput + Number(a.totalConsumeToken)
    				}
    			})
    			
    			v.chatTotal = v.chatInput + v.chatOutput
    			v.workTotal = v.workInput + v.workOutput
    			v.totalInput = v.chatInput + v.workInput
    			v.totalOutput = v.chatOutput + v.workOutput
    			v.allTokenTotal = v.chatTotal + v.workTotal
    			return {
    				...v
    			}
    		})
    		this.total = res?.data?.data?.total || 0
    	} catch (error) {
    
    	} finally {
    		this.noLogin()
    	}
    },
    handleReset() {
      this.form = { schoolId: null, year: '', term: '' }
      this.startDate = ''
      this.endDate = ''
      this.tableData = []
    }
  }
}
</script>